module.exports = __webpack_public_path__ + "img/bbc.f08c31a0.png";